import React from "react";
import { jobPoolCopy, validWorkScope } from "./jobPoolCopy";

// Display an explicit canonical scope allowlist. Never spread quote data, prices,
// raw customer notes, photos or links into the worker's job cards.
export default function JobScopeDetails({ scope, lang = "en" }) {
  const t = jobPoolCopy[lang] || jobPoolCopy.en;
  if (!validWorkScope(scope)) return <p>{t.scopeMissing}</p>;
  const extras = Array.isArray(scope.extras) ? scope.extras.filter(value => typeof value === "string") : [];
  return <section className="space-y-2" aria-label={t.workScope} data-testid="job-work-scope">
    <h4 className="font-bold">{t.workScope}</h4>
    <dl className="space-y-1"><div><dt className="inline font-semibold">{t.product}: </dt><dd className="inline">{scope.product}</dd></div>
      {typeof scope.model === "string" && scope.model && <div><dt className="inline font-semibold">{t.model}: </dt><dd className="inline">{scope.model}</dd></div>}
      {typeof scope.dimensions === "string" && scope.dimensions && <div><dt className="inline font-semibold">{t.dimensions}: </dt><dd className="inline">{scope.dimensions}</dd></div>}
      <div><dt className="inline font-semibold">{t.quantity}: </dt><dd className="inline">{scope.quantity}</dd></div>
    </dl><p className="font-semibold">{t.extras}</p>{extras.length ? <ul className="list-disc pl-5">{extras.map((extra, index) => <li key={index}>{extra}</li>)}</ul> : <p>{t.noExtras}</p>}
  </section>;
}
